import EmptyState from "Components/organisms/empty-state"
import ContinuingEducationBudgetSummary from "models/continuing-education-budget"
import { formatCurrency } from "utils/tools"

interface ContinuingEducationBudgetSummaryProps {
    budget: ContinuingEducationBudgetSummary | null
}

const ContinuingEducationBudgetSummaryView = ({ budget }: ContinuingEducationBudgetSummaryProps) => {
    if (!budget || budget.allocatedAmount === null) {
        return <EmptyState
            title={"No budget allocated"}
            subtitle={"There is no continuing education budget for this fiscal year"}
        />
    }

    const fiscalYearLabel = `FY ${budget.fiscalYearId} (Sep ${budget.fiscalYearId - 1} - Aug ${budget.fiscalYearId})`

    return (
        <div className="overview-header-grid">
            <div>
                <label>Fiscal Year:</label>
                <div>{fiscalYearLabel}</div>
            </div>

            <div>
                <label>Allocated: </label>
                <div>{formatCurrency(budget.allocatedAmount)}</div>
            </div>

            <div>
                <label>Remaining (incl. Pending): </label>
                <div>{formatCurrency(budget.holdRemainingBudget)}</div>
            </div>

            <div>
                <label>Remaining (Approved only): </label>
                <div>{formatCurrency(budget.actualRemainingBudget)}</div>
            </div>
        </div>
    )
}

export default ContinuingEducationBudgetSummaryView